module.exports = __webpack_public_path__ + "static/media/sound.17454587.mp3";